import * as React from "react";
import { LiveScore } from "../LiveScore";
import { TeamsWrapper } from "../TeamsWrapper";
export const EventCardDetailsInfoAmericanMobile = (props) => {
    const noLeague = props.details.showLeagueInEventCard
        ? ""
        : `rj-ev-list__${props.componentPrefix}__section-item--no-league`;
    const inKickOff = props.details.event.isInKickOffState
        ? `rj-ev-list__${props.componentPrefix}__section-item--in-kick-off`
        : "";
    const classNames = `rj-ev-list__${props.componentPrefix}__section rj-ev-list__${props.componentPrefix}__event-info ${noLeague} ${inKickOff}`;
    return (React.createElement("a", { href: props.details.event.linkUrl, onClick: props.details.handlers.eventCard, className: `${classNames} `, "data-uat": `a-ev-list-${props.componentPrefix}-event-info` },
        React.createElement(TeamsWrapper, { details: props.details, componentPrefix: props.componentPrefix }),
        React.createElement(LiveScore, { event: props.details.event, componentPrefix: props.componentPrefix })));
};
//# sourceMappingURL=EventCardDetailsInfoAmericanMobile.js.map